import "../.././styles/Constitution.css";

function ArticleThree(){
    return(
        <>
            <div className="container">
                <div className="sub-container constitution" >
                    <h3>ARTICLE III: MEMBERS OF THE CORPORATION</h3>
                    <h5>3.1 Membership</h5>
                    <ol type="a">
                        <li><p>
                            The Governing Board may admit natural persons who are Canadian citizens or
                            permanent residents of Canada residing in Manitoba and who are 18 years or older as
                            members of the corporation.
                        </p></li>
                        <li><p>
                            The Governing Board through the recommendation of the Membership Committee may
                            determine the conditions and criteria for membership as it deems necessary.
                            Applications that do not comply with such conditions and criteria may be refused.
                        </p></li>
                        <li><p>
                            Membership is not transferrable.
                        </p></li>
                        <li><p>
                            Automatic termination of membership occur immediately upon receipt of notification
                            of death of a natural member, written resignation, and non-payment of membership
                            fees on prescribed deadline.
                        </p></li>
                    </ol>
                </div>
            </div>
            <div className="container">
                <div className="sub-container constitution" id="section-even">
                    <h5>3.2 Categories</h5>
                    <ol type="I">
                        <li><p>
                            <b>Regular Member - </b>Membership in the corporation is open to every Canadian citizen
                            or permanent resident of Canada with ancestral origin from the Philippines who:
                        </p></li>
                        <ol type="a" className="indent">
                            <li><p>
                                has been a resident of Manitoba for at least one year;
                            </p></li>
                            <li><p>
                                has attained the minimum age of 18 years;
                            </p></li>
                            <li><p>
                                actively supports the principles and objectives of the corporation;
                            </p></li>
                            <li><p>
                                demonstrates their intention to join the corporation in good faith; and
                            </p></li>
                            <li><p>
                                has completed &amp; signed membership application and paid the corporation’s annual
                                membership fee in person at the PCCM administration office.
                            </p></li>
                        </ol>
                        <br /><br />
                        <li><p>
                            <b>Affiliate Member - </b>Includes groups or organizations whose membership are
                            comprised of Canadian citizens or permanent residents in Canada, with ancestral origins
                            from the Philippines, who:
                        </p></li>
                        <ol type="a" className="indent">
                            <li><p>
                                demonstrates their intention to join the corporation by submitting copy of their latest
                                Annual Return that has been filed at the Manitoba Companies Office, or copy of their
                                Minutes of Meeting or Resolution providing details of reasons for membership as an
                                affiliatemember of the corporation;
                            </p></li>
                            <li><p>
                                must be able to submit a copy of their latest Financial Statements (Income Statement,
                                Cash Flow Statement, and Balance Sheet);
                            </p></li>
                            <li><p>
                                actively supports the principles and objectives of the corporation; and
                            </p></li>
                            <li><p>
                                affiliate members shall pay an annual fee, as determined on an annual basis by the
                                Membership Committee. An affiliate member shall be represented by their President or
                                designate who shall enjoy all the rights and privileges of active members as prescribed
                                by these by-laws.
                            </p></li>
                        </ol>
                        <br /><br />
                        <li><p>
                            <b>Student Member - </b>Shall be open to any college or university student in Manitoba
                            whose ancestral origin is from the Philippines, who:
                        </p></li>
                        <ol type="a" className="indent">
                            <li><p>
                                must be 18 years or older at time of application;
                            </p></li>
                            <li><p>
                                must have the ability to provide support in furthering the objects of the corporation; and
                            </p></li>
                            <li><p>
                                shall pay a prescribed annual fee. Student members shall enjoy all the rights and
                                privileges of active members as prescribed by these by-laws.
                            </p></li>
                        </ol>
                        <br /><br />
                        <li><p>
                            <b>Life Member - </b>Is open to individuals who are Canadian citizens or permanent residents
                            in Canada, with ancestral origin from the Philippines, who:
                        </p></li>
                        <ol type="a" className="indent"> 
                            <li><p>
                                at time of admission, must be 65 years or older; and
                            </p></li>
                            <li><p>
                                no annual fee is required and shall enjoy all the rights and privileges of active members,
                                as prescribed by these by-laws.
                            </p></li>
                        </ol>
                    </ol>
                </div>
            </div>
            <div className="container">
                <div className="sub-container constitution">
                    <h5>3.3 Rights and Privileges</h5>
                    <ol type="a">
                        <li><p>
                            participate in the Annual General Membership Meeting;
                        </p></li>
                        <li><p>
                            vote for, and stand for election as Member of the Governing Boardor officers of the
                            corporation;
                        </p></li>
                        <li><p>
                            vote at all meetings of the general membership;
                        </p></li>
                        <li><p>
                            Individual members are entitled to a 10% discount basic rent in the occasional use of
                            the Multi-Purpose Room (MPR) to a maximum of one-time 8-hour use per calendar year
                            and on a first-come-first serve basis; and
                        </p></li>
                        <li><p>
                            affiliate members are entitled to free basic rent in the occasional use of the MPR to a
                            maximum of one-time 8-hour use per calendar year and on a first-come-first serve
                            basis.
                        </p></li>
                    </ol>
                </div>
            </div>
            <div className="container">
                <div className="sub-container constitution" id="section-even">
                    <h5>3.4 Membership Fees</h5>
                    <ol type="a">
                        <li><p>
                            The Governing Board shall prescribe the annual membership fees payable by each
                            category of Members, and shall fix a due date for payment of annual membership fees.
                        </p></li>
                        <li><p>
                            Membership Fees must be paid individually in the form of cash or cheque at the
                            administration office. Without exceptions, no applications and payments of
                            membership fees will be accepted if done by a group or groups.
                        </p></li>
                    </ol>
                </div>
            </div>
            <div className="container">
                <div className="sub-container constitution">
                    <h5>3.5 Resignation, Suspension, and Expulsion of Members</h5>
                    <ol type="a">
                        <li><p>
                            Any member may resign his, her or its membership by delivering a written notice to
                            that effect to the Membership Committee of the corporation;
                        </p></li>
                        <li><p>
                            Membership in the corporation is not assignable or transferable;
                        </p></li>
                        <li><p>
                            Any member who has not paid his, her or its fees or assessments, if any, on the due
                            date shall automatically have his, her or its rights and privileges as a member revoked
                            and may only be reinstated at the discretion of the Governing Board by a majority vote;
                        </p></li>
                        <li><p>
                            The Governing Board may, by two-thirds majority, expel any member who they believe
                            has acted, or is acting, in a manner contrary to the best interests of the corporation; and
                        </p></li>
                        <li><p>
                            Any Member who resigns, is suspended, or is expelled immediately forfeits all rights
                            and privileges associated with membership in the corporation.
                        </p></li>
                    </ol>
                </div>
            </div>
        </>
    );
}

export default ArticleThree;